import type { ReactNode } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';

interface QueryStateGuardProps<T> {
  query: UseQueryResult<T>;
  noDataMessage?: string;
  children: (data: NonNullable<T>) => ReactNode;
}

export function QueryStateGuard<T>({
  query,
  noDataMessage = 'No data found.',
  children,
}: QueryStateGuardProps<T>) {
  if (query.isLoading) {
    return <div className="text-sm text-gray-500 dark:text-zinc-400">Loading...</div>;
  }

  if (query.isError) {
    return <div className="text-red-600 dark:text-red-400">Error loading upload details.</div>;
  }

  if (query.data == null) {
    return <div className="text-sm text-gray-500 dark:text-zinc-400">{noDataMessage}</div>;
  }

  return <>{children(query.data)}</>;
}
